export default function getURLSegment(url, index) {
    return url.split("/")[index];
}
